export const DIGIT_TWO = 2;
export const DIGIT_SIX_HUNDRED = 600;
export const DIGIT_TWO_FIFTY_SIX = 256;
export const DIGIT_TWO_THIRTY_TWO = 232;
export const DIGIT_HUNDRED = 100;
export const DIGIT_ONE_EIGHTY = 180;
